(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = 0;
  var scrubSections = [];

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function updateScrubs() {
    frame = 0;
    if (reducedMotion.matches) return;

    scrubSections.forEach(function (item) {
      var section = item.section;
      var video = item.video;
      if (!video.duration || !Number.isFinite(video.duration)) return;

      var rect = section.getBoundingClientRect();
      var progress;

      if (item.compact) {
        var compactTravel = window.innerHeight + rect.height;
        progress = clamp((window.innerHeight - rect.top) / compactTravel, 0, 1);
      } else {
        var travel = Math.max(1, rect.height - window.innerHeight);
        progress = clamp(-rect.top / travel, 0, 1);
      }

      var target = progress * Math.max(0, video.duration - 0.05);
      if (Math.abs(video.currentTime - target) > 0.035 && !video.seeking) {
        video.currentTime = target;
      }
    });
  }

  function requestScrubUpdate() {
    if (!frame) frame = window.requestAnimationFrame(updateScrubs);
  }

  function initializeScrubs() {
    document.querySelectorAll('[data-scrub]').forEach(function (section) {
      var video = section.querySelector('video');
      var poster = section.querySelector('.walk-poster, .compact-film-poster');
      if (!video) return;
      var source = video.getAttribute('data-video-src');

      var item = {
        section: section,
        video: video,
        compact: section.hasAttribute('data-compact')
      };
      scrubSections.push(item);

      function loadVideo() {
        if (!source || video.src || reducedMotion.matches) return;
        video.preload = 'metadata';
        video.src = source;
        video.load();
      }

      function markReady() {
        video.classList.add('is-ready');
        if (poster) poster.classList.add('is-hidden');
        requestScrubUpdate();
      }

      if (video.readyState >= 1) markReady();
      else video.addEventListener('loadedmetadata', markReady, { once: true });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            loadVideo();
            observer.disconnect();
          }
        }, { rootMargin: '300px 0px' });
        observer.observe(section);
      } else {
        loadVideo();
      }
    });

    window.addEventListener('scroll', requestScrubUpdate, { passive: true });
    window.addEventListener('resize', requestScrubUpdate);
    reducedMotion.addEventListener('change', requestScrubUpdate);
    requestScrubUpdate();
  }

  function initializeProductionFilm() {
    var section = document.querySelector('[data-production-film]');
    if (!section || reducedMotion.matches) return;

    function loadFilm() {
      if (section.querySelector('iframe')) return;

      var iframe = document.createElement('iframe');
      iframe.title = 'Smythe and Digby atelier: one pair getting made';
      // Full film (no trim), captions on, no related-video suggestions.
      // Film ID comes from the section's data-film-id (theme editor setting).
      var filmId = section.getAttribute('data-film-id') || 'vkct7g5EM6s';
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + filmId + '?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&playsinline=1&iv_load_policy=3&disablekb=1&cc_load_policy=1&cc_lang_pref=en&loop=1&playlist=' + filmId;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.tabIndex = -1;
      iframe.addEventListener('load', function () {
        window.setTimeout(function () {
          iframe.classList.add('is-ready');
          var poster = section.querySelector('.production-poster');
          if (poster) poster.classList.add('is-hidden');
        }, 1800);
      });
      section.insertBefore(iframe, section.firstChild.nextSibling);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          loadFilm();
          observer.disconnect();
        }
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    } else {
      loadFilm();
    }
  }

  function initializeMenu() {
    var button = document.querySelector('.house-menu');
    var menu = document.querySelector('.house-mobile-nav');
    var openIcon = document.querySelector('.menu-open-icon');
    var closeIcon = document.querySelector('.menu-close-icon');
    if (!button || !menu) return;

    function setOpen(open) {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      menu.hidden = !open;
      if (openIcon) openIcon.hidden = open;
      if (closeIcon) closeIcon.hidden = !open;
    }

    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });
  }

  function scrollToHash() {
    if (!window.location.hash) return;
    var target = document.getElementById(window.location.hash.slice(1));
    if (target) window.requestAnimationFrame(function () { target.scrollIntoView(); });
  }

  /* ---- Conversion additions -------------------------------------------- */

  // Sticky mobile CTA: appears once the hero is behind you, hides at the footer.
  function initializeStickyCta() {
    var bar = document.querySelector('.sticky-cta');
    var hero = document.querySelector('.walk-chapter--oxford');
    if (!bar || !hero) return;

    var pending = false;

    function apply() {
      pending = false;
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      var doc = document.documentElement;
      var atFooter = window.scrollY + window.innerHeight > doc.scrollHeight - 200;
      bar.classList.toggle('is-visible', pastHero && !atFooter);
    }

    function schedule() {
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    apply();
  }

  // Email capture. Posts to data-endpoint when one is set; until then it hands
  // the address to the brand inbox so no signup is silently dropped.
  function initializeCapture() {
    var form = document.querySelector('[data-capture-form]');
    if (!form) return;

    var input = form.querySelector('input[type="email"]');
    var note = form.querySelector('.capture-note');
    var endpoint = form.getAttribute('data-endpoint');
    var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function say(message) {
      if (note) note.textContent = message;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = ((input && input.value) || '').trim();

      if (!pattern.test(value)) {
        say('Please enter a valid email address.');
        if (input) input.focus();
        return;
      }

      if (endpoint) {
        var button = form.querySelector('button');
        if (button) button.disabled = true;
        say('Sending...');
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: value, source: 'house_page' })
        }).then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          form.reset();
          say('You are on the list. The sizing notes are on their way.');
        }).catch(function () {
          say('That did not go through. Try again, or email info@smytheanddigby.com.');
        }).then(function () {
          if (button) button.disabled = false;
        });
        return;
      }

      var subject = encodeURIComponent('Sizing notes request');
      var body = encodeURIComponent('Please send me the sizing notes and measuring guide.' + value);
      window.location.href = 'mailto:info@smytheanddigby.com?subject=' + subject + '&body=' + body;
      say('Opening your email app. Send it and we will reply with the sizing notes.');
    });
  }

  // CTA tracking. Pushes to dataLayer whether or not GA4 is configured, so the
  // events are ready the moment a measurement ID is added.
  function initializeCtaTracking() {
    window.dataLayer = window.dataLayer || [];
    document.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || typeof node.closest !== 'function') return;
      var el = node.closest('[data-cta]');
      if (!el) return;
      window.dataLayer.push({
        event: 'cta_click',
        cta_label: el.getAttribute('data-cta') || 'unknown',
        cta_location: el.getAttribute('data-cta-location') || 'unknown'
      });
    }, { passive: true });
  }

  initializeScrubs();
  initializeProductionFilm();
  initializeMenu();
  scrollToHash();
  initializeStickyCta();
  initializeCapture();
  initializeCtaTracking();
})();
